import { render, staticRenderFns } from "./Animations.vue?vue&type=template&id=6706a161&"
import script from "./Animations.vue?vue&type=script&lang=js&"
export * from "./Animations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports